import { isFeatureEnabled } from '@lumapps/features';

import { DISTRIBUTE_CONTENT_FF } from '../constants';

export const isDistributeContentEnabled = isFeatureEnabled(DISTRIBUTE_CONTENT_FF);
